import { Link } from 'react-router-dom';
import { ArrowLeft, FileText, Award, ExternalLink, Users } from 'lucide-react';
import { Button } from '../components/ui/button';
import { elezioni2025, candidatiComunali } from '../data/siteData';

export const ElezioniComunali = () => {
  return (
    <div className="min-h-screen pt-20" data-testid="elezioni-comunali-page">
      {/* Hero Section */}
      <section className="bg-gradient-to-b from-[#002060] to-[#003380] py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-white/80 hover:text-white mb-8 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Torna alla home
          </Link>
          
          <div className="text-center">
            <span className="text-xs uppercase tracking-widest font-semibold text-[#5CB9E5] mb-4 block">
              Elezioni 2025
            </span>
            <h1 className="font-serif text-4xl md:text-6xl font-bold text-white mb-4">
              Candidati Comunali
            </h1>
            <p className="text-2xl text-[#FFD700] font-medium mb-2">
              Aosta 2025
            </p>
            <p className="text-white/80">
              Lista LA RENAISSANCE VALDÔTAINE
            </p>
          </div>
        </div>
      </section>

      {/* Candidato Sindaco Section */}
      <section className="py-16 bg-white" data-testid="sindaco-section">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            {/* Sindaco */}
            <div className="bg-[#F4F6F8] rounded-xl p-8 text-center border-t-4 border-[#FFD700]">
              <div className="w-24 h-24 bg-[#002060] rounded-full mx-auto mb-6 flex items-center justify-center">
                <Award className="w-12 h-12 text-[#FFD700]" />
              </div>
              <span className="text-xs uppercase tracking-widest font-semibold text-[#5CB9E5] mb-2 block">
                Candidato Sindaco
              </span>
              <h2 className="font-serif text-2xl font-bold text-[#002060] mb-4">
                {elezioni2025.comunali.candidatoSindaco.nome}
              </h2>
              <div className="flex flex-col gap-2">
                <a 
                  href={elezioni2025.comunali.candidatoSindaco.cv}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 text-[#002060] hover:text-[#5CB9E5] transition-colors"
                >
                  <FileText className="w-4 h-4" />
                  Curriculum Vitae
                  <ExternalLink className="w-3 h-3" />
                </a>
                <a 
                  href={elezioni2025.comunali.candidatoSindaco.certificato}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 text-[#002060] hover:text-[#5CB9E5] transition-colors"
                >
                  <FileText className="w-4 h-4" />
                  Certificato Penale
                  <ExternalLink className="w-3 h-3" />
                </a>
              </div>
            </div>

            {/* Vicesindaco */}
            <div className="bg-[#F4F6F8] rounded-xl p-8 text-center border-t-4 border-[#5CB9E5]">
              <div className="w-24 h-24 bg-[#002060] rounded-full mx-auto mb-6 flex items-center justify-center">
                <Users className="w-12 h-12 text-[#5CB9E5]" />
              </div>
              <span className="text-xs uppercase tracking-widest font-semibold text-[#5CB9E5] mb-2 block">
                Candidato Vicesindaco
              </span>
              <h2 className="font-serif text-2xl font-bold text-[#002060] mb-4">
                {elezioni2025.comunali.candidatoVice.nome}
              </h2>
              <div className="flex flex-col gap-2">
                <a 
                  href={elezioni2025.comunali.candidatoVice.cv}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 text-[#002060] hover:text-[#5CB9E5] transition-colors"
                >
                  <FileText className="w-4 h-4" />
                  Curriculum Vitae
                  <ExternalLink className="w-3 h-3" />
                </a>
                <a 
                  href={elezioni2025.comunali.candidatoVice.certificato}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 text-[#002060] hover:text-[#5CB9E5] transition-colors"
                >
                  <FileText className="w-4 h-4" />
                  Certificato Penale
                  <ExternalLink className="w-3 h-3" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Lista Candidati */}
      <section className="py-16 bg-[#F4F6F8]" data-testid="candidati-list-section">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="text-center mb-12">
            <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#002060] mb-4">
              Lista dei Candidati
            </h2>
            <p className="text-slate-600">
              {candidatiComunali.length} candidati al Consiglio Comunale di Aosta
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            {candidatiComunali.map((candidato, index) => (
              <div 
                key={index}
                className="bg-white rounded-lg p-5 shadow-sm hover:shadow-md transition-shadow border-l-4 border-[#5CB9E5]"
                data-testid={`candidato-card-${index}`}
              >
                <div className="flex items-start justify-between gap-3">
                  <div className="flex-1">
                    <span className="text-xs text-[#5CB9E5] font-semibold">
                      {String(index + 1).padStart(2, '0')}
                    </span>
                    <h3 className="font-semibold text-[#002060] mt-1">
                      {candidato.nome}
                    </h3>
                  </div>
                </div>
                <div className="flex gap-4 mt-4 text-sm">
                  <a 
                    href={candidato.cv}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#002060] hover:text-[#5CB9E5] transition-colors flex items-center gap-1"
                  >
                    <FileText className="w-3 h-3" />
                    CV
                  </a>
                  <a 
                    href={candidato.certificato}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#002060] hover:text-[#5CB9E5] transition-colors flex items-center gap-1"
                  >
                    <FileText className="w-3 h-3" />
                    Certificato
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Programma CTA */}
      <section className="py-16 bg-[#002060]">
        <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
          <h2 className="font-serif text-3xl font-bold text-white mb-4">
            Scopri il nostro programma
          </h2>
          <p className="text-white/80 mb-8">
            Le nostre proposte per il Comune di Aosta
          </p>
          <a 
            href={elezioni2025.comunali.programma}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button className="btn-gold px-8 py-3 rounded-lg font-semibold flex items-center gap-2 mx-auto">
              <FileText className="w-5 h-5" />
              Scarica il Programma
              <ExternalLink className="w-4 h-4" />
            </Button>
          </a>
        </div>
      </section>
    </div>
  );
};
